export default __webpack_public_path__ + "static/media/token_tier.08fbc8bf.png";